import { getAppName } from './getAppName.js'

// Builds the x-scantrust-device header string based on available device info
const getDeviceHeader = async function (data, deviceInfo = null) {
  /* Possible fields for this header
    model: The device model number (e.g. SM-G650)
    app: The app name (replace x-scantrust-app header)
    lang: The user language
    sdk-version: The version of the SDK (doesn't apply here, there is no SDK)
    os: The operating system (e.g. Android, iOs)
    os-version: The operating system version (e.g. 12.0.1)
  */
  let header = `app=${await getAppName()};`

  if (deviceInfo) {
    if (deviceInfo.model) {
      header += `model=${deviceInfo.model};`
    }
    if (deviceInfo.os) {
      header += `os=${deviceInfo.os};`
    }
    if (deviceInfo.osVersion) {
      header += `os_version=${deviceInfo.osVersion};`
    }
    if (deviceInfo.browser) {
      header += `browser=${deviceInfo.browser};`
    }
    if (deviceInfo.browserVersion) {
      header += `browser_version=${deviceInfo.browserVersion};`
    }
    if (deviceInfo.browserEngine) {
      header += `browser_engine=${deviceInfo.browserEngine};`
    }
  } else {
    if (data?.device) {
      header += `model=${data.device};`
    }
    if (data?.os) {
      header += `os=${data.os};`
    }
    if (data?.os_version) {
      header += `os_version=${data.os_version};`
    }
    if (data?.browser) {
      header += `browser=${data.browser};`
    }
    if (data?.browserVersion) {
      header += `browser_version=${data.browserVersion};`
    }
    if (data?.browserEngine) {
      header += `browser_engine=${data.browserEngine};`
    }
  }

  return header
}

export default getDeviceHeader
